import * as React from 'react';

import styles from './DocumentMessageLayout.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { ChatMessageBubble } from '../../../ChatMessageBubble';
import { ChatMessage } from '../../../ChatMessage';
import { MetaRow } from '../MetaRow';

interface IDocumentMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  documentMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  userColor?: EUserColor;
  replyQuote: React.ReactNode | null;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const DocumentMessageLayout = React.forwardRef<HTMLDivElement, IDocumentMessageLayoutProps>(
  function DocumentMessageLayout(
    {
      errorSign,
      errorText,
      messageType,
      isLastMessageInChain,
      documentMessage,
      messageMeta,
      userColor,
      replyQuote,
      highlighted,
      onHighlightEnd,
    },
    ref,
  ) {
    return (
      <ChatMessage errorSign={errorSign} errorText={errorText}>
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['document-message__bubble']}
          ref={ref}
          userColor={userColor}
          highlighted={highlighted}
          onHighlightEnd={onHighlightEnd}
        >
          <div className={styles['document-message__quote']}>{replyQuote}</div>
          {documentMessage}
          <MetaRow messageType={messageType} userColor={userColor}>
            {messageMeta}
          </MetaRow>
        </ChatMessageBubble>
      </ChatMessage>
    );
  },
);
